import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { FundDetails, FundPriceChart, MutualFund } from 'src/app/models/mutualFund';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { UrlConstants } from '../models/urlConstants';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FundService {
  private sendingOrderSubject = new BehaviorSubject<boolean>(false);
  sendingOrder$ = this.sendingOrderSubject.asObservable();

  constructor(private apiService: ApiService,
    private http: HttpClient,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {}

  getMutualFundList(symbolCode?: string,fundType?:number): Observable<{ funds: MutualFund[]; selectedFund: MutualFund }> {
    return this.apiService.GetMutualFundList(fundType).pipe(
      map((res: MutualFund[]) => {
        if (!res || res.length === 0) {
          return { funds: [], selectedFund: null };
        }
        let selectedFund = symbolCode
          ? res.find(fund => fund.SymbolCode === symbolCode)
          : res[0];

        res.forEach(fund => (fund.selected = fund === selectedFund));

        if (!selectedFund) {
          selectedFund = res[0];
          selectedFund.selected = true;
        }

        return { funds: res, selectedFund };
      })
    );
  }

  getFundTypes(): Observable<any> {
    return this.apiService.GetMutualFundTypes();
  }

  sendOrder(
    orderDetails: any,
    quantity: number,
    orderTotal: number,
    FundDetails: any,
    selectedAccount: any,
    orderForm: any,
    stepper: any
  )

  {
    orderTotal = parseFloat(orderTotal.toFixed(2));
    if (
      (FundDetails.CurencyID === 1 && orderDetails.BalanceEGP > orderTotal) ||
      (FundDetails.CurencyID === 2 && orderDetails.BalanceUSD > orderTotal)
    ) {
      const orderPayload = {
        SymbolCode: FundDetails.SymbolCode,
        Qty: quantity,
        Price: FundDetails.ClosePrice,
        TakeMarketPrice: false,
        ISMSCDBook: false,
        OrderType: 1,
        TiffFlag: 1,
        TiffDate: orderForm.get('tiffDate').value,
        FillFlag: orderForm.get('execRule').value,
        relationCode: selectedAccount.relationCode,
        CustodianCode: null,
        ISOPR: false,
        MinFillVolume: orderForm.get('minFillVolume').value,
      };
      this.http
        .post(`${UrlConstants.backofficeUrl}/api/OfflineOrders/PostOfflineOrder`, orderPayload)
        .pipe(
          catchError((error) => {
            this.sendingOrderSubject.next(false);
            this.toastr.error('', this.translate.instant('order-failure'), {
              timeOut: 15000,
              positionClass: 'toast-bottom-center',
              closeButton: true,
            });
            return [];
          })
        )
        .subscribe({
          next: (res) => {
            if (res['Errors']?.length > 0) {
              this.sendingOrderSubject.next(false);
              this.toastr.error('', this.translate.instant(res['Errors'][0]), {
                timeOut: 15000,
                positionClass: 'toast-bottom-center',
                closeButton: true,
              });
            } else {
              this.sendingOrderSubject.next(true);
              this.toastr.info('', this.translate.instant('new-order-success'), {
                timeOut: 15000,
                positionClass: 'toast-bottom-center',
                closeButton: true,
              });
              stepper.next();
            }
          },
        });
    } else {
      this.toastr.warning('', this.translate.instant('insufficient-funds'), {
        timeOut: 15000,
        positionClass: 'toast-bottom-center',
        closeButton: true,
      });
    }
  }

  getMutualFundDetails(symbolCode: string): Observable<FundDetails> {
    return this.apiService.GetMutualFundDetails(symbolCode).pipe(
      map((res: FundDetails) => {
        if (!res) return null;

        if (res.PdfsUrls) {
          res.PdfsUrlsList = res.PdfsUrls.split(',');
        }
        return res;
      })
    );
  }

  getFundPriceHistory(symbolCode: string): Observable<any> {
    return this.apiService.GetFundPriceHistory(symbolCode);
  }
}
